export const CountryData = Object.freeze({
    // AUS: {
    //     name: 'Australia',
    //     postCode: {
    //         maxLength: 4,
    //         minLength: 4,
    //         term: 'Post Code',
    //     },
    // },
    // CAN: {
    //     name: 'Canada',
    //     postCode: {
    //         maxLength: 6,i
    //         minLength: 6,
    //         term: 'Postal Code',
    //     },
    // },
    GBR: {
        name: 'United Kingdom',
        postCode: {
            maxLength: 8,
            minLength: 5,
            term: 'Post Code',
        },
    },
    IRL: {
        name: 'Ireland',
        postCode: {
            maxLength: 7,
            minLength: 7,
            term: 'EIR Code',
        },
    },
    // LUX: {
    //     name: 'Luxembourg',
    //     postCode: {
    //         maxLength: 4,
    //         minLength: 4,
    //         term: 'Post Code',
    //     },
    // },
    // USA: {
    //     name: 'United States of America',
    //     postCode: {
    //         maxLength: 5,
    //         minLength: 5,
    //         term: 'Zip Code',
    //     },
    // },
});

export const PaymentStatuses = Object.freeze({
    PAYMENT_STATUS_UNPAID: 'unpaid',
    PAYMENT_STATUS_PAID: 'paid',
    PAYMENT_STATUS_REQUIRES_ACTION: 'requires_action',
});



// WEBPACK FOOTER //
// ./src/Assets/config.js